<app-header (onClickFeatures)="onClickFeatures()" (onClickDetails)="onClickDetails()" (onClickConcept)="onClickConcept()" (onClickOpportunities)="onClickOpportunities()" [features]="features" [details]="details" [concept]="concept" [opportunities]="opportunities"
    [footer]="footer"></app-header>
<div class="content-container vertical-container">
    <app-quick-look></app-quick-look>
    <div class="divider"></div>
    <br>
    <span #features></span>
    <br>
    <br>
    <br>
    <app-features></app-features>
    <br>
    <br>
    <div class="divider"></div>
    <br>
    <span #details></span>
    <br>
    <br>
    <br>
    <app-details></app-details>
    <div class="divider"></div>
    <br>
    <span #concept></span>
    <br>
    <br>
    <br>
    <app-concept></app-concept>
    <br>
    <span #opportunities></span>
    <br>
    <br>
    <br>
    <app-opportunities></app-opportunities>
    <span #footer></span>
    <br>
    <br>
    <app-footer style="width: 100%;"></app-footer>
</div>